module.exports = __webpack_public_path__ + "media/images/search-white-416422608a2073a98c24c151b1eefd35.svg";